let errors = {};
export const validate = function (fields, key) {
	if (typeof fields[key].value !== 'undefined' && (!fields[key].value) && fields[key].required) {
		fields[key].error = 'This field is required'

	} else {
		fields[key].error = undefined
	}

	if (fields[key].type === 'checkbox' && fields[key].required) {
		if (fields[key].checked) {
			fields[key].error = undefined
		} else {
			fields[key].error = 'This field is required'
		}
	}

	if (fields[key].type === 'email') {
		if (!/\S+@\S+\.\S+/.test(fields[key].value)) {
			fields[key].error = 'Email address is invalid';
		} else {
			fields[key].error = undefined
		}
	}

	if (fields[key].type === 'tel') {
		if (!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(fields[key].value)) {
			fields[key].error = 'Phone number is invalid';
		} else {
			fields[key].error = undefined
		}
	}
	return errors;
};

